import React, {Component} from 'react';
import DatePicker, {registerLocale} from 'react-datepicker';
import moment from 'moment';
import es from 'date-fns/locale/es';
import {Input} from 'semantic-ui-react';
import {dateFormatShow, dateFormatPicker} from '../../../constants/datesFormat';
import 'react-datepicker/dist/react-datepicker.css';

registerLocale('es', es);

class DatePickerField extends Component {
  render() {
    const {disabled, required, placeholder, minDate, maxDate, 'input': {...input}} = this.props;
    return (
      <DatePicker
        {...input}
        customInput={ <Input icon='calendar' size='small' /> }
        dateFormat={dateFormatPicker}
        value={input.value ? moment(input.value, dateFormatShow).toDate() : null}
        selected={input.value ? moment(input.value, dateFormatShow).toDate() : null}
        minDate={moment(minDate || null).toDate()}
        maxDate={moment(maxDate || null).add(30, 'days').toDate()}
        locale='es'
        placeholderText={placeholder}
        required={required}
        disabled={disabled}
        onChange={input.onChange}
        autoComplete='off'
      />
    );
  }
}

export default DatePickerField;
